import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ProtectedAreaOtherUseDetailSyncResultDto } from '../dtos/protected-area-other-use-detail/models';

@Injectable({
  providedIn: 'root',
})
export class ProtectedAreaOtherUseDetailOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  obtainProtectedAreaOtherUseDetail = (cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProtectedAreaOtherUseDetailSyncResultDto>({
      method: 'POST',
      url: '/api/orchestrator/protected-area-other-use-detail/sync',
    },
    { apiName: this.apiName,...config });
}